export default __webpack_public_path__ + "static/media/Mo_daijoubu.6d281874.mp3";